import { action, makeObservable, observable } from "mobx"

import { LockRewardStore } from "@/domains/lock-rewards/lock-reward-store"
import {
  ClaimEverythingByNftFormat,
  LockRewardSelectionStrategy,
} from "@/domains/lock-rewards/strategies/selection/lock-reward-selection-strategy"
import { rewardsToMultiNftClaimEverythingFormat } from "@/domains/lock-rewards/strategies/selection/rewards-to-claim-format"

export class TokenSelectionStrategy implements LockRewardSelectionStrategy<string> {
  selectedTokenAddresses: Set<string> = new Set()

  constructor() {
    makeObservable(this, {
      selectedTokenAddresses: observable,
      toggle: action,
      clear: action,
    })
  }

  toggle(tokenAddress: string): void {
    if (this.selectedTokenAddresses.has(tokenAddress)) {
      this.selectedTokenAddresses.delete(tokenAddress)
    } else {
      this.selectedTokenAddresses.add(tokenAddress)
    }
  }

  clear(): void {
    this.selectedTokenAddresses.clear()
  }

  has(tokenAddress: string): boolean {
    return this.selectedTokenAddresses.has(tokenAddress)
  }

  selected(): string[] {
    return Array.from(this.selectedTokenAddresses)
  }

  filteredSelected(currentRewards: LockRewardStore[]): LockRewardStore[] {
    const selectedRewards =
      this.selectedTokenAddresses.size > 0
        ? currentRewards.filter((reward) => this.selectedTokenAddresses.has(reward.token.address.toString()))
        : currentRewards

    return selectedRewards
  }

  toClaimFormat(currentRewards: LockRewardStore[]): Array<ClaimEverythingByNftFormat> {
    const selectedRewards = this.filteredSelected(currentRewards)
    return rewardsToMultiNftClaimEverythingFormat(selectedRewards)
  }

  strategyName(): string {
    return "token-selection"
  }
}
